"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLanguage } from "@/components/LanguageContext";
import { ROUTES } from "@/lib/localizedRoutes";
import { brandConfig } from "@/lib/brandConfig";

// The links page keeps the complete route list; both menus use the same short list.
export const menuItems = ROUTES
    .filter(route => route.menu?.showInHeader === true)
    .map(route => ({
        key: route.key,
        label: route.label,
        paths: route.paths,
        href: route.paths.hu,
        showInLinks: route.menu?.showInLinks === true,
    }));

const primaryKeys = ["strike-zone", "prices", "private-room", "gift-card", "opening-hours", "faq", "booking"];
const primaryItems = primaryKeys.map(key => menuItems.find(item => item.key === key)).filter(Boolean);

export default function MainMenu({ onItemClick, variant = "header" }) {
    const pathname = usePathname();
    const { language } = useLanguage();
    const isHeader = variant === "header";
    const isEnglish = language === "en";

    return (
        <nav style={{ "--brand-primary": brandConfig.colors.primary }}
            aria-label={isHeader ? (isEnglish ? "main menu" : "főmenü") : (isEnglish ? "footer menu" : "lábléc menü")}
            className={isHeader
                ? "mx-auto flex w-full max-w-[560px] items-center justify-center px-6 py-8 md:py-10"
                : "mt-8 flex flex-col items-center text-white"}>
            <ul className={isHeader ? "flex w-full flex-col items-center gap-5" : "flex flex-col items-center gap-3"}>
                {primaryItems.map(item => {
                    const href = item.paths[language] || item.paths.hu;
                    const active = pathname === href;
                    const isBooking = isHeader && item.key === "booking";
                    const label = item.key === "strike-zone"
                        ? (isEnglish ? "about the game" : "a játékról")
                        : item.key === "prices"
                            ? (isEnglish ? "prices" : "árak")
                            : item.label[language] || item.label.hu;
                    return (
                        <li key={item.key} className={isBooking ? "w-full" : undefined}>
                            <Link href={href} onClick={onItemClick} aria-current={active ? "page" : undefined}
                                className={isBooking
                                    ? "button-pulse mx-auto flex min-h-[52px] w-full max-w-xs items-center justify-center rounded-[6px] bg-[var(--brand-primary)] px-6 text-[21px] font-black text-black transition hover:scale-[1.02]"
                                    : isHeader
                                        ? `block text-center text-[21px] leading-tight transition-colors hover:text-[var(--brand-primary)] md:text-[24px] ${active ? "text-[var(--brand-primary)]" : "text-white"}`
                                        : `${item.key === "booking" ? "button-pulse" : ""} block text-center text-[20px] leading-none transition-colors hover:text-[var(--brand-primary)] md:text-[16px] ${active ? "text-[var(--brand-primary)]" : "text-neutral-300"}`}>
                                {label}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
